/**
 * Wizard 3 plan overview, extras, and flavor-line checkout.
 * One household date. Portions and flavors stay per dog.
 */
(function (root) {
  var ORDER = ['rund', 'kip', 'vis'];
  var SAMPLES = { rund: '58584603427080', kip: '58584603459848', vis: '58584603492616' };
  var PORTIONS = ['complete', 'half', 'topper'];
  var MULTIPLIER = { complete: 1, half: 2, topper: 4 };
  var ALLERGY = { beef: 'rund', rund: 'rund', kip: 'kip', chicken: 'kip', vis: 'vis', fish: 'vis' };
  var EXTRAS = [
    { id: 'sardine_oil', modal: 'sardine-oil', accent: 'accent accent--freshwater shape_1' },
    { id: 'beef_trainers', modal: 'beef-trainers', accent: 'accent accent--beef shape_2' },
    { id: 'lamb_tripe', modal: 'lamb-tripe', accent: 'accent accent--lamb shape_3' },
    { id: 'duck_trainers', modal: 'duck-trainers', accent: 'accent accent--duck shape_4' }
  ];
  var EXTRA_ALLERGY = {
    lamb_tripe: ['lam', 'lamb'],
    duck_trainers: ['eend', 'duck'],
    beef_trainers: ['rund', 'beef']
  };
  var WARNING_ICON = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/warning_status_color.svg?v=1768301061';
  var FLAVOR_PHOTO = {
    rund: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/Forever_Food_-_Beef_Main_-_No_BG.webp?v=1790862304',
    kip: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/Forever_Food_-_Chicken_Main_-_No_BG.webp?v=1790862304',
    vis: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/Forever_Food_-_FIsh_Main_-_No_BG.webp?v=1790862304'
  };
  var BOWL = {
    complete: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/filled_bowl.webp?v=1773925349',
    half: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/half_filled_bowl.webp?v=1773925349',
    topper: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/topper_bowl.webp?v=1790863359'
  };
  var TICK = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/tick_success.svg?v=1768397998';
  var STORY_PHOTOS = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/polaroids.webp?v=1791281981';
  var STORY_VET = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/Blue_Zone_Peter_Klaver.webp?v=1791285236';
  var STORY_BOWLS = [
    'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/Beef_half-bowl_b5d73adc-eeb3-4081-93ee-c40469dec5b3.webp?v=1791987942',
    'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/Chicken_half-bowl_3f6cd37b-5197-4db8-b94b-754348b8068f.webp?v=1791987942',
    'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/Fish_half-bowl_5eed4eb3-581b-40b6-87c1-62d1e239c0e8.webp?v=1791987942'
  ];
  var STORY_VIDEO = {
    id: 'vidalytics_embed_jsFDzORdlrWSST7p',
    src: 'https://fast.vidalytics.com/embeds/UP88wHuq/jsFDzORdlrWSST7p/'
  };
  var ROUTINE_PHOTO = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/routine-hero.webp?v=1791984880';
  var ROUTINE_MARK = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/food-water.webp?v=1789114358';
  var FLAVOR_ACCENT = {
    rund: 'accent accent--beef shape_2',
    kip: 'accent accent--chicken shape_3',
    vis: 'accent accent--fish shape_4'
  };
  var opened = {};
  var stickyObserver = null;
  var extraMedia = {};
  var lastHandler = null;
  var priceCache = {};
  var renderToken = 0;
  var bowlTimer = null;

  function decodeCopy(value) {
    return String(value || '')
      .replace(/&amp;/g, '&')
      .replace(/&#39;|&apos;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  }

  function copy(key) {
    var node = root.__wizard3Copy || {};
    String(key || '').split('.').forEach(function (part) {
      node = node && node[part];
    });
    return typeof node === 'string' ? decodeCopy(node) : '';
  }

  function fill(template, vars) {
    var value = String(template || '');
    Object.keys(vars || {}).forEach(function (name) {
      value = value.replace(new RegExp('%\\{' + name + '\\}', 'g'), vars[name]);
    });
    return value;
  }

  function nl() {
    return String((root.document && root.document.documentElement.lang) || root.__wizardCurrentLocale || 'nl').toLowerCase().indexOf('nl') === 0;
  }

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function moneyStringToCents(value) {
    if (value == null) return 0;
    var s = String(value).trim();
    if (!s) return 0;
    var match = s.match(/^(-?\d+)(?:\.(\d+))?$/);
    if (!match) {
      var n = Number(s);
      return Number.isFinite(n) ? Math.round(n * 100) : 0;
    }
    var sign = match[1].indexOf('-') === 0 ? -1 : 1;
    var intPart = Math.abs(parseInt(match[1], 10)) || 0;
    var frac = (match[2] || '') + '000';
    var cents2 = (parseInt(frac.charAt(0), 10) || 0) * 10 + (parseInt(frac.charAt(1), 10) || 0);
    var cents = intPart * 100 + cents2 + ((parseInt(frac.charAt(2), 10) || 0) >= 5 ? 1 : 0);
    return sign * cents;
  }

  function box1Off() {
    var off = Number(journey() && journey().pricing && journey().pricing.box1_pct_off);
    return Number.isFinite(off) ? off : 0.5;
  }

  function formatCents(handler, amount, currency) {
    var rounded = Math.round(Number(amount) || 0);
    var code = currency ? String(currency).toUpperCase() : '';
    if (code && handler.flow && handler.flow.state) handler.flow.state.presentmentCurrencyCode = code;
    if (handler.formatWizardMoney) return handler.formatWizardMoney(rounded);
    if (typeof root.formatMoney === 'function') {
      var locale = handler.getWizardFormatLocaleForMoney ? handler.getWizardFormatLocaleForMoney() : (root.document && root.document.documentElement.lang);
      return root.formatMoney(rounded / 100, code || 'EUR', locale);
    }
    return (rounded / 100).toFixed(2);
  }

  function journey() {
    return root.BzWizard && root.BzWizard.current ? root.BzWizard.current() : null;
  }

  function shipCount(bags, days, horizon) {
    var naturalDays = Math.max(1, Number(days) || 1);
    var naturalBags = Math.max(1, Number(bags) || 1);
    var exact = (naturalBags * horizon) / naturalDays;
    return Math.max(1, Math.ceil(exact - 1e-9));
  }

  function bandFor(kg) {
    var bands = (journey() && journey().pricing && journey().pricing.bag_price_bands) || [];
    var weight = Math.min(Math.max(Number(kg) || 1, 1), 100);
    var found = bands.find(function (row) { return weight >= row.min_kg && weight <= row.max_kg; });
    return found || bands[bands.length - 1] || { shopify_eur: 0, topper_eur: 0 };
  }

  function allergic(dog, flavorId) {
    return (dog.allergies || []).some(function (token) {
      return ALLERGY[String(token).toLowerCase()] === flavorId;
    });
  }

  function extraAllergyWarning(handler, extraId) {
    var tokens = EXTRA_ALLERGY[extraId];
    if (!tokens) return '';
    var state = handler.flow && handler.flow.state;
    var dogs = state && state.ensureDogs ? state.ensureDogs() : [];
    var names = dogs.filter(function (dog) {
      return (dog.allergies || []).some(function (token) {
        return tokens.indexOf(String(token).toLowerCase()) !== -1;
      });
    }).map(function (dog) { return dog.name; }).filter(Boolean);
    if (!names.length) return '';
    var andWord = nl() ? 'en' : 'and';
    var label = names.length === 1 ? names[0] : names.slice(0, -1).join(', ') + ' ' + andWord + ' ' + names[names.length - 1];
    var text = '';
    if (handler.getLocaleString) text = handler.getLocaleString('quiz.steps.flavors.allergy_warning', { pet_name: label }) || '';
    if (!text) return '';
    return '<div class="inline-message" data-message-type="warning">' +
      '<span class="warning-icon" aria-hidden="true"><img src="' + WARNING_ICON + '" alt="" width="16" height="16"></span>' +
      '<p class="inline-message-text">' + esc(text) + '</p></div>';
  }

  function sampleFlavors(dog) {
    if (dog.eating !== 'picky' && dog.eating !== 'very_picky') return [];
    var selected = dog.flavors || [];
    return ORDER.filter(function (id) {
      return selected.indexOf(id) === -1 && !allergic(dog, id);
    });
  }

  function defaultFlavors(dog, maxFlavors) {
    var picked = [];
    var cap = Math.max(1, Math.min(Number(maxFlavors) || 1, 3));
    ORDER.forEach(function (id) {
      if (picked.length >= cap) return;
      if (allergic(dog, id)) return;
      picked.push(id);
    });
    if (!picked.length) picked.push('rund');
    return picked;
  }

  function trimFlavors(flavors, maxFlavors) {
    var selected = (flavors || []).slice();
    var cap = Math.max(1, Math.min(Number(maxFlavors) || 1, 3));
    var removeOrder = root.FlavorDistribution && root.FlavorDistribution.getFlavorTrimOrder
      ? root.FlavorDistribution.getFlavorTrimOrder()
      : ORDER.slice().reverse();
    while (selected.length > cap) {
      var victim = removeOrder.find(function (id) { return selected.indexOf(id) !== -1; });
      if (!victim) break;
      selected.splice(selected.indexOf(victim), 1);
    }
    return selected.filter(function (id) { return ORDER.indexOf(id) !== -1; });
  }

  function naturalPlan(handler, dog) {
    var engine = handler.flow.calculationEngine;
    var calc = engine.calculate({
      name: dog.name,
      gender: dog.gender,
      spayed: dog.spayed,
      ageGroup: dog.ageGroup,
      breed: dog.breed,
      weight: Number(dog.weight) || 1,
      composition: dog.composition,
      activity: dog.activity,
      snacks: dog.snacks,
      allergies: dog.allergies || []
    });
    return {
      bags: Math.max(1, Number(calc.bagCount) || 1),
      days: Math.max(1, Math.round(Number(calc.matchDays) || 1))
    };
  }

  function compute(handler) {
    var state = handler.flow.state;
    var dogs = state.ensureDogs();
    var naturals = dogs.map(function (dog) { return naturalPlan(handler, dog); });
    var horizon = naturals.reduce(function (min, plan, index) {
      var portion = dogs[index].portion === 'half' || dogs[index].portion === 'topper' ? dogs[index].portion : 'complete';
      return Math.min(min, plan.days * MULTIPLIER[portion]);
    }, Infinity);
    if (!Number.isFinite(horizon)) horizon = 25;
    var combinedKg = state.combinedWeightKg ? state.combinedWeightKg() : dogs.reduce(function (sum, dog) {
      return sum + (Number(dog.weight) || 0);
    }, 0);
    var band = bandFor(combinedKg);
    var cards = dogs.map(function (dog, index) {
      var plan = naturals[index];
      var completeShip = shipCount(plan.bags, plan.days, horizon);
      var options = PORTIONS.map(function (id) {
        var naturalDays = plan.days * MULTIPLIER[id];
        var ship = shipCount(plan.bags, naturalDays, horizon);
        return {
          id: id,
          ship: ship,
          hidden: id !== 'complete' && ship === completeShip,
          displayBags: plan.bags,
          displayDays: naturalDays
        };
      });
      return { options: options };
    });
    return { dogs: dogs, naturals: naturals, horizon: horizon, band: band, combinedKg: combinedKg, cards: cards };
  }

  function prepare(handler) {
    lastHandler = handler;
    var state = handler.flow.state;
    var guard = 0;
    var model = compute(handler);
    while (guard < 6) {
      guard += 1;
      var changed = false;
      model.dogs.forEach(function (dog, index) {
        var card = model.cards[index];
        var portion = dog.portion === 'half' || dog.portion === 'topper' ? dog.portion : 'complete';
        var chosen = card.options.find(function (option) { return option.id === portion; });
        if (!chosen || chosen.hidden) {
          state.setDogField(index, 'portion', 'complete');
          changed = true;
          portion = 'complete';
          chosen = card.options[0];
        } else if (dog.portion !== portion) {
          state.setDogField(index, 'portion', portion);
          changed = true;
        }
        var cap = Math.max(1, Math.min(chosen.ship, 3));
        var flavors = dog.flavors || [];
        if (!flavors.length) {
          state.setDogField(index, 'flavors', defaultFlavors(dog, cap));
          state.setDogField(index, 'flavorsDefaulted', true);
          changed = true;
        } else if (flavors.length > cap) {
          state.setDogField(index, 'flavors', trimFlavors(flavors, cap));
          changed = true;
        }
      });
      model = compute(handler);
      if (!changed) break;
    }
    var all = [];
    model.dogs.forEach(function (dog) {
      (dog.flavors || []).forEach(function (id) {
        if (all.indexOf(id) === -1) all.push(id);
      });
    });
    state.selectedFlavorsTrial = all.slice();
    state.selectedFlavorsFull = all.slice();
    return model;
  }

  function activeIndex(state) {
    var count = state.ensureDogs().length;
    var index = Number(state.w3PlanDog);
    if (!Number.isFinite(index) || index < 0 || index >= count) index = 0;
    return index;
  }

  function setPlanDog(handler, index) {
    var state = handler.flow.state;
    var count = state.ensureDogs().length;
    var next = Math.max(0, Math.min(count - 1, index));
    state.w3PlanDog = next;
    if (handler.flow.storage && state.getState) {
      handler.flow.storage.autoSave(state.getState(), state.customerId);
    }
    return next;
  }

  function planButtonLabel(state) {
    var dogs = state.ensureDogs();
    var index = activeIndex(state);
    if (index < dogs.length - 1) {
      return fill(copy('continue_to'), { name: dogs[index + 1].name || '' });
    }
    return copy('checkout');
  }

  function optionOf(card, id) {
    return card.options.find(function (option) { return option.id === id; }) || card.options[0];
  }

  function breedLabel(dog) {
    var value = String(dog.breed || '').trim();
    if (dog.breedUnknown || dog.breedMixed || value === 'dont_know' || value === 'mixed' || !value) {
      return copy('breed_mixed');
    }
    if (value === 'other' && root.WizardBreedEntry && root.WizardBreedEntry.otherLabel) {
      return root.WizardBreedEntry.otherLabel();
    }
    var rows = root.Wizard1Breeds || [];
    var row = rows.find(function (item) { return item.value === value; });
    if (!row) return value;
    return nl() ? row.label_nl : row.label_en;
  }

  function ageLabel(dog) {
    var key = dog.ageGroup === 'puppy' || dog.ageGroup === 'senior' ? dog.ageGroup : 'adult';
    return copy('age_' + key);
  }

  function weightLabel(dog) {
    var n = Number(dog.weight);
    if (!Number.isFinite(n)) return '';
    return String(Math.round(n * 10) / 10).replace(/\.0$/, '');
  }

  function flavorName(handler, id) {
    var key = 'quiz.steps.flavors.flavor_' + id;
    var value = handler.getLocaleString ? handler.getLocaleString(key) : '';
    if (value && value !== key) return value;
    var fallback = { rund: nl() ? 'Rund' : 'Beef', kip: nl() ? 'Kip' : 'Chicken', vis: nl() ? 'Vis' : 'Fish' };
    return fallback[id] || id;
  }

  function possessive(name) {
    var clean = String(name || '').trim();
    if (!clean) return '';
    return /s$/i.test(clean) ? clean + "'" : clean + "'s";
  }

  function accentName(name) {
    return '<span class="accent accent--freshwater shape_1 nowrap">' + esc(name) + '</span>';
  }

  function flavorFlow(handler, flavors) {
    var names = (flavors || []).filter(function (id) { return ORDER.indexOf(id) !== -1; });
    if (!names.length) names = ['rund'];
    return names.map(function (id, index) {
      var piece = '<span class="' + FLAVOR_ACCENT[id] + ' nowrap">' + esc(flavorName(handler, id)) + '</span>';
      if (index === 0) return piece;
      var lead = index === names.length - 1 ? ' ' + esc(copy('and')) + ' ' : ', ';
      return '<span class="w3-join">' + lead + '</span>' + piece;
    }).join('');
  }

  function bagsHtml(flavors, dogIndex) {
    var names = (flavors || []).filter(function (id) { return FLAVOR_PHOTO[id]; });
    if (!names.length) names = ['rund'];
    var ordered = ORDER.filter(function (id) { return names.indexOf(id) !== -1; });
    if (!ordered.length) ordered = names.slice(0, 1);
    var images = ordered.slice().reverse().map(function (id, index) {
      return '<img data-w3-slot="' + (ordered.length - index) + '" alt="" src="' + FLAVOR_PHOTO[id] + '">';
    });
    return '<div class="w3-bags" data-count="' + ordered.length + '" data-flavors="' + esc(names.join('|')) + '" data-dog="' + dogIndex + '">' + images.join('') + '</div>';
  }

  function revealBags(bags) {
    if (!bags || bags.getAttribute('data-count') === '1') return;
    var reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      bags.classList.add('is-revealed');
      return;
    }
    root.requestAnimationFrame(function () {
      root.requestAnimationFrame(function () { bags.classList.add('is-revealed'); });
    });
  }

  function benefits(id) {
    var lines = [];
    var i = 1;
    while (copy('benefit_' + id + '_' + i)) {
      lines.push(copy('benefit_' + id + '_' + i));
      i += 1;
    }
    var lead = copy('lead_' + id);
    return '<p class="w3-lead">' + esc(lead) + '</p><ul class="w3-benefits">' + lines.map(function (line) {
      return '<li><img alt="" src="' + TICK + '" width="16" height="11"><span>' + esc(line) + '</span></li>';
    }).join('') + '</ul>';
  }

  function priceLine(handler, option) {
    var quote = option && option.quote;
    if (!quote) return '';
    var per = copy('per_day');
    return '<span class="w3-price-was">' + esc(formatCents(handler, quote.list, quote.currency)) + '</span>' +
      '<span class="w3-price-now">' + esc(formatCents(handler, quote.first, quote.currency) + per) + '</span>';
  }

  function quoteKey(dog, option, kg) {
    var dist = root.FlavorDistribution
      ? root.FlavorDistribution.calculateFlavorDistribution(option.displayBags, dog.flavors || [])
      : {};
    var lines = [];
    ORDER.forEach(function (id) {
      var qty = dist[id] || 0;
      if (!qty) return;
      var row = foodVariant(id, option.id, kg);
      if (!row || !row.shopify_variant_id) return;
      lines.push({ id: String(row.shopify_variant_id), qty: qty });
    });
    var off = box1Off();
    return {
      lines: lines,
      off: off,
      key: lines.map(function (line) { return line.id + 'x' + line.qty; }).join(',') + '/' + option.displayDays + '/' + off
    };
  }

  function quoteOption(handler, dog, option, kg) {
    var built = quoteKey(dog, option, kg);
    var lines = built.lines;
    var off = built.off;
    var key = built.key;
    if (priceCache[key]) return Promise.resolve(priceCache[key]);
    var api = handler.flow && handler.flow.shopifyAPI;
    if (!api || !api.getVariant || !lines.length) return Promise.resolve(null);
    return Promise.all(lines.map(function (line) { return api.getVariant(line.id); })).then(function (variants) {
      var total = 0;
      var currency = '';
      lines.forEach(function (line, index) {
        var variant = variants[index];
        if (!variant || variant.price == null) return;
        if (!currency && variant.currency) currency = variant.currency;
        total += moneyStringToCents(variant.price) * line.qty;
      });
      var days = Math.max(1, option.displayDays);
      var quote = {
        list: total / days,
        first: Math.round(total * (1 - off)) / days,
        currency: currency
      };
      priceCache[key] = quote;
      return quote;
    }).catch(function () { return null; });
  }

  function paintQuotes(handler, rootEl, card, selected) {
    card.options.forEach(function (option) {
      var el = rootEl.querySelector('[data-w3-price="' + option.id + '"]');
      if (el) el.textContent = option.quote ? formatCents(handler, option.quote.first, option.quote.currency) + copy('per_day') : '';
    });
    var summary = rootEl.querySelector('[data-w3-summary]');
    if (summary) {
      summary.innerHTML = '<span class="w3-off-badge">' + esc(copy('off_badge')) + '</span>' +
        '<span class="w3-summary__line"><span>' + esc(copy('first_box')) + '</span>' + priceLine(handler, selected) + '</span>';
    }
    paintSticky(handler, selected);
  }

  function loadQuotes(handler, rootEl, dog, card, kg, selected, token) {
    Promise.all(card.options.filter(function (option) { return !option.hidden; }).map(function (option) {
      return quoteOption(handler, dog, option, kg).then(function (quote) { option.quote = quote; });
    })).then(function () {
      if (token !== renderToken) return;
      if (handler.flow.state.getCurrentStep && handler.flow.state.getCurrentStep() !== 'plan_overview') return;
      paintQuotes(handler, rootEl, card, selected);
    });
  }

  function paintSticky(handler, option) {
    var sticky = root.document.querySelector('[data-sticky-trial-row]');
    var label = root.document.querySelector('[data-sticky-trial-label]');
    var compare = root.document.querySelector('[data-sticky-trial-compare]');
    var finalPrice = root.document.querySelector('[data-sticky-trial-final]');
    var row = sticky && sticky.querySelector('.wizard-sticky-price-row');
    var quote = option && option.quote;
    if (label) label.textContent = copy('first_box');
    if (compare) compare.textContent = quote ? formatCents(handler, quote.list, quote.currency) : '';
    if (finalPrice) finalPrice.textContent = quote ? formatCents(handler, quote.first, quote.currency) + copy('per_day') : '';
    if (sticky && label && row && !sticky.querySelector('[data-w3-sticky-line]')) {
      var line = root.document.createElement('span');
      line.className = 'w3-summary__line';
      line.setAttribute('data-w3-sticky-line', '');
      sticky.insertBefore(line, label);
      line.appendChild(label);
      line.appendChild(row);
    }
    if (sticky && !sticky.querySelector('[data-w3-badge]')) {
      var badge = root.document.createElement('span');
      badge.className = 'w3-off-badge';
      badge.setAttribute('data-w3-badge', '');
      badge.textContent = copy('off_badge');
      sticky.appendChild(badge);
    }
    var full = root.document.querySelector('[data-sticky-full-plan-row]');
    if (full) full.style.display = 'none';
  }

  function watchSticky(rootEl) {
    if (stickyObserver) stickyObserver.disconnect();
    var button = rootEl.querySelector('[data-w3-go]');
    var box = root.document.querySelector('.quiz-container');
    if (!button || !box || typeof root.IntersectionObserver !== 'function') {
      if (box) box.classList.add('w3-sticky-on');
      return;
    }
    stickyObserver = new root.IntersectionObserver(function (entries) {
      var visible = entries.some(function (entry) { return entry.isIntersecting; });
      box.classList.toggle('w3-sticky-on', !visible);
    }, { threshold: 0.2 });
    stickyObserver.observe(button);
  }

  function asset(name) {
    var bag = root.__wizard3Assets || {};
    return bag[name] || '';
  }

  function icon(name) {
    return '<img alt="" src="' + esc(asset(name)) + '">';
  }

  function loveTitle(text) {
    var words = String(text || '').trim().split(/\s+/);
    var last = words.pop() || '';
    var hearts = '<span class="w3-hearts" aria-hidden="true">' + icon('heart') + icon('heart') + icon('heart') + '</span>';
    return (words.length ? esc(words.join(' ')) + ' ' : '') + '<span class="w3-love-end">' + esc(last) + hearts + '</span>';
  }

  function storyBowls(dog) {
    var chosen = (dog.flavors || []).filter(function (id) { return ORDER.indexOf(id) !== -1; });
    var ids = chosen.length ? ORDER.filter(function (id) { return chosen.indexOf(id) !== -1; }) : ORDER.slice();
    return ids.map(function (id) { return STORY_BOWLS[ORDER.indexOf(id)]; });
  }

  function formatScoopCount(scoops) {
    if (!Number.isFinite(scoops) || scoops <= 0) return '';
    if (Math.abs(scoops - 0.25) < 0.001) return '¼';
    var whole = Math.floor(scoops + 1e-9);
    var fraction = Math.round((scoops - whole) * 2) / 2;
    if (fraction >= 1) {
      whole += 1;
      fraction = 0;
    }
    if (fraction === 0) return String(whole);
    if (Math.abs(fraction - 0.5) < 0.001) return whole === 0 ? '½' : whole + '½';
    return String(scoops);
  }

  function feedingAmounts(grams) {
    var foodG = Math.round(Number(grams) || 0);
    var foodScoops = Math.round((foodG / 45) * 2) / 2;
    if (foodScoops < 0.25) foodScoops = 0.25;
    var waterScoops = Math.round((foodScoops / 2.5) * 2) / 2;
    if (waterScoops < 0.25) waterScoops = 0.25;
    return { grams: foodG, foodScoops: foodScoops, waterMl: Math.round(waterScoops * 80), scoops: waterScoops };
  }

  function routinePronouns(dog) {
    var female = dog && dog.gender === 'female';
    if (nl()) {
      return female
        ? { pronoun: 'haar', object: 'haar', subject: 'ze' }
        : { pronoun: 'zijn', object: 'hem', subject: 'hij' };
    }
    return female
      ? { pronoun: 'her', object: 'her', subject: 'she' }
      : { pronoun: 'his', object: 'him', subject: 'he' };
  }

  function routineFeed(handler, dog) {
    var engine = handler.flow && handler.flow.calculationEngine;
    var portion = dog.portion === 'half' || dog.portion === 'topper' ? dog.portion : 'complete';
    var grams = 0;
    if (engine && engine.calculate) {
      var calc = engine.calculate({
        name: dog.name,
        gender: dog.gender,
        spayed: dog.spayed,
        ageGroup: dog.ageGroup,
        breed: dog.breed,
        weight: Number(dog.weight) || 1,
        composition: dog.composition,
        activity: dog.activity,
        snacks: dog.snacks,
        allergies: dog.allergies || []
      });
      grams = (Number(calc.dailyFoodG) || 0) / MULTIPLIER[portion];
    }
    return feedingAmounts(grams);
  }

  function scoopLine(scoops) {
    return fill(copy('routine_scoop_line'), {
      count: formatScoopCount(scoops),
      unit: copy(scoops < 2 ? 'routine_scoop_one' : 'routine_scoop_many')
    });
  }

  function routineHtml(handler, dog) {
    var name = dog.name || '';
    var pronouns = routinePronouns(dog);
    var feed = routineFeed(handler, dog);
    var lead = esc(fill(copy('routine_lead_before'), {
      name: name,
      pronoun: pronouns.pronoun,
      object: pronouns.object,
      subject: pronouns.subject
    })) + '<strong>' + esc(copy('routine_lead_bold')) + '</strong>' + esc(copy('routine_lead_after'));
    return '<section class="w3-routine">' +
      '<img class="w3-routine__photo" alt="" width="780" height="780" src="' + ROUTINE_PHOTO + '">' +
      '<div class="w3-routine__copy">' +
        '<div class="w3-routine__intro">' +
          '<h2 class="w3-story-title">' +
            '<span class="accent accent--freshwater shape_3 nowrap">' + esc(possessive(name)) + '</span> ' +
            esc(fill(copy('routine_title'), { pronoun: pronouns.pronoun })) +
          '</h2>' +
          '<p class="w3-routine__lead">' + lead + '</p>' +
        '</div>' +
        '<div class="w3-routine__servings">' +
          '<p class="w3-routine__amount"><strong>' + esc(String(feed.grams)) + 'g</strong><br>' +
            esc(copy('routine_food')) + '<br>' + esc(scoopLine(feed.foodScoops)) + '</p>' +
          '<img class="w3-routine__mark" alt="" width="80" height="80" src="' + ROUTINE_MARK + '">' +
          '<p class="w3-routine__amount"><strong>' + esc(String(feed.waterMl)) + 'ml</strong><br>' +
            esc(copy('routine_water')) + '<br>' + esc(scoopLine(feed.scoops)) + '</p>' +
        '</div>' +
      '</div>' +
    '</section>';
  }

  function storyHtml(handler, dog, count, bowls) {
    var name = dog.name || '';
    var noun = copy(count === 1 ? 'story_recipe_one' : 'story_recipe_many');
    var features = [
      ['microwave', 'story_fresh'],
      ['tail', 'story_guarantee'],
      ['hands', 'story_clear'],
      ['ready', 'story_ready']
    ].map(function (row) {
      return '<li>' + icon(row[0]) + '<span>' + esc(copy(row[1])) + '</span></li>';
    }).join('');
    return '<div class="w3-story">' +
      '<section class="w3-story-benefits">' +
        '<div class="w3-story-benefits__copy">' +
          '<h2 class="w3-story-title">' +
            '<span class="w3-strike">' +
              '<span class="w3-strike__note">' + esc(copy('story_script')) + '</span>' +
              esc(copy('story_struck')) +
              '<img class="w3-strike__line" alt="" width="69" height="10" src="' + esc(asset('strike')) + '">' +
            '</span> ' +
            esc(copy('story_standard')) + ' ' +
            accentName(name) +
          '</h2>' +
          '<ul class="w3-story-benefits__list">' +
            '<li>' + icon('tick') + '<span>' + esc(copy('story_benefit_1')) + '</span></li>' +
            '<li>' + icon('tick') + '<span>' + esc(copy('story_benefit_2')) + '</span></li>' +
            '<li>' + icon('tick') + '<span>' + esc(copy('story_benefit_3')) + '</span></li>' +
          '</ul>' +
        '</div>' +
        '<img class="w3-story-benefits__photos" alt="" src="' + STORY_PHOTOS + '">' +
      '</section>' +
      '<section class="w3-reassure">' +
        '<div class="w3-reassure__video" data-w3-video></div>' +
        '<div class="w3-reassure__copy">' +
          '<h2 class="w3-story-title">' + loveTitle(copy('story_love')) + '</h2>' +
          '<p class="w3-story-lead">' + esc(fill(copy('story_try'), { name: name })) + '</p>' +
        '</div>' +
        '<ul class="w3-features">' + features + '</ul>' +
      '</section>' +
      '<section class="w3-recipe-story">' +
        '<h2 class="w3-story-title">' +
          accentName(possessive(name)) + ' ' +
          esc(copy('story_plan')) + ' ' +
          esc(copy('story_contains')) + ' ' +
          String(count) + ' ' +
          esc(copy('story_vet')) + ' ' +
          esc(noun) +
        '</h2>' +
        '<div class="w3-bowl">' +
          '<img class="w3-bowl__photo" alt="" width="1005" height="1005" data-w3-bowl src="' + esc((bowls && bowls[0]) || STORY_BOWLS[0]) + '">' +
          '<img class="w3-bowl__arrow w3-bowl__arrow--meat" alt="" src="' + esc(asset('arrow1')) + '">' +
          '<p class="w3-bowl__note w3-bowl__note--meat">' + esc(copy('story_meat')) + '</p>' +
          '<img class="w3-bowl__arrow w3-bowl__arrow--vitamins" alt="" src="' + esc(asset('arrow2')) + '">' +
          '<p class="w3-bowl__note w3-bowl__note--vitamins">' + esc(copy('story_vitamins')) + '</p>' +
          '<img class="w3-bowl__arrow w3-bowl__arrow--clear" alt="" src="' + esc(asset('arrow3')) + '">' +
          '<p class="w3-bowl__note w3-bowl__note--clear">' + esc(copy('story_clear')) + '</p>' +
        '</div>' +
        '<a href="#" class="w3-story-link" data-open-nutrition-modal>' + esc(copy('story_nutrition')) + '</a>' +
        '<figure class="w3-vet">' +
          '<span class="w3-vet__photo">' +
            '<img class="w3-vet__frame" alt="" src="' + esc(asset('frame')) + '">' +
            '<img class="w3-vet__face" alt="" src="' + STORY_VET + '">' +
          '</span>' +
          '<figcaption>' +
            '<p class="w3-vet__name">' + esc(copy('story_vet_name')) + '</p>' +
            '<p class="w3-vet__quote">' + esc(copy('story_vet_quote')) + '</p>' +
          '</figcaption>' +
        '</figure>' +
      '</section>' +
      routineHtml(handler, dog) +
    '</div>';
  }

  function mountVideo(slot) {
    if (!slot || slot.getAttribute('data-ready')) return;
    slot.setAttribute('data-ready', '1');
    var holder = root.document.createElement('div');
    holder.id = STORY_VIDEO.id;
    holder.style.width = '100%';
    holder.style.position = 'relative';
    holder.style.paddingTop = '100%';
    slot.appendChild(holder);
    var script = root.document.createElement('script');
    script.text = '(function (v, i, d, a, l, y, t, c, s) {' +
      "y='_'+d.toLowerCase();c=d+'L';if(!v[d]){v[d]={};}if(!v[c]){v[c]={};}if(!v[y]){v[y]={};}" +
      "var vl='Loader',vli=v[y][vl],vsl=v[c][vl+'Script'],vlf=v[c][vl+'Loaded'],ve='Embed';" +
      'if(!vsl){vsl=function(u,cb){if(t){cb();return;}s=i.createElement("script");s.type="text/javascript";s.async=1;s.src=u;' +
      'if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}' +
      'i.getElementsByTagName("head")[0].appendChild(s);};}' +
      'vsl(l+"loader.min.js",function(){if(!vli){var vlc=v[c][vl];vli=new vlc();}vli.loadScript(l+"player.min.js",function(){var vec=v[d][ve];t=new vec();t.run(a);});});' +
      '})(window, document, "Vidalytics", "' + STORY_VIDEO.id + '", "' + STORY_VIDEO.src + '");';
    slot.appendChild(script);
  }

  function stopBowl() {
    if (!bowlTimer) return;
    clearInterval(bowlTimer);
    bowlTimer = null;
  }

  function startBowl(img, bowls) {
    stopBowl();
    if (!img) return;
    var list = bowls && bowls.length ? bowls : STORY_BOWLS;
    var index = 0;
    img.src = list[0];
    if (list.length < 2) return;
    var reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    bowlTimer = setInterval(function () {
      index = (index + 1) % list.length;
      img.src = list[index];
    }, 1500);
  }

  function mountOverview(handler) {
    var rootEl = handler.currentStepElement && handler.currentStepElement.querySelector('[data-wizard-overview]');
    if (!rootEl) return;
    if (handler.setupFlavorModalListeners) handler.setupFlavorModalListeners();
    if (handler.bindWizardFlavorModal) handler.bindWizardFlavorModal();
    var model;
    try {
      model = prepare(handler);
    } catch (e) {
      var missing = handler.checkMissingRequiredSteps && handler.checkMissingRequiredSteps();
      if (missing && handler.flow && handler.flow.router) {
        handler.flow.router.navigate(missing);
        return;
      }
      throw e;
    }
    var state = handler.flow.state;
    var index = activeIndex(state);
    state.w3PlanDog = index;
    var dog = model.dogs[index];
    var card = model.cards[index];
    var selected = optionOf(card, dog.portion);
    var name = dog.name || '';
    var flavorCount = (dog.flavors || []).filter(function (id) { return ORDER.indexOf(id) !== -1; }).length;
    var bowls = storyBowls(dog);
    var sentence = fill(copy(flavorCount > 1 ? 'sentence' : 'sentence_one'), {
      age: esc(ageLabel(dog)),
      weight: esc(weightLabel(dog)),
      breed: esc(breedLabel(dog))
    });
    var cards = card.options.filter(function (option) { return !option.hidden; }).map(function (option) {
      var folded = option.id !== 'complete' && option.id !== dog.portion && !opened[index + ':' + option.id];
      var badge = option.id === 'complete'
        ? '<span class="wizard-edge-badge">' + esc(copy('badge_best')) + '</span>'
        : (option.id === 'topper' ? '<span class="wizard-edge-badge wizard-edge-badge--muted">' + esc(copy('badge_low')) + '</span>' : '');
      return '<button type="button" class="w3-option' + (option.id === dog.portion ? ' is-selected' : '') + (folded ? ' is-folded' : '') + '" data-w3-portion="' + option.id + '">' +
        badge +
        '<span class="w3-option__head">' +
          '<img alt="" src="' + BOWL[option.id] + '" width="52" height="52">' +
          '<span class="w3-option__meta"><span class="w3-option__name">' + esc(copy('portion_' + option.id)) + '</span>' +
          '<span class="w3-option__price" data-w3-price="' + option.id + '"></span></span>' +
          '<span class="w3-radio" aria-hidden="true"></span>' +
        '</span>' +
        '<span class="w3-option__more">' + benefits(option.id) + '</span>' +
      '</button>';
    }).join('');
    var flavorKey = (dog.flavors || []).join('|');
    var previous = rootEl.querySelector('.w3-bags');
    var keepBags = previous && previous.getAttribute('data-flavors') === flavorKey && previous.getAttribute('data-dog') === String(index);
    var keptBags = keepBags ? previous : null;
    var keptVideo = rootEl.querySelector('[data-w3-video][data-ready]');
    var token = ++renderToken;
    var buttonLabel = planButtonLabel(state);
    var counter = model.dogs.length > 1
      ? '<p class="w3-count">' + (index + 1) + ' ' + esc(copy('of')) + ' ' + model.dogs.length + '</p>'
      : '';
    rootEl.innerHTML =
      '<div class="w3-plan" data-active-dog="' + index + '">' +
        '<div class="w3-hero">' +
          '<div class="w3-hero__copy">' +
            counter +
            '<h2>' + esc(copy('title_before')) + ' ' + accentName(name) + '</h2>' +
            '<p class="w3-sentence"><span>' + esc(copy('our')) + '</span> <span class="w3-display">' + esc(copy('forever')) + '</span> ' +
              flavorFlow(handler, dog.flavors) + ' <span>' + sentence + '</span></p>' +
          '</div>' +
          bagsHtml(dog.flavors, index) +
        '</div>' +
        '<section class="w3-panel">' +
          '<h2 class="w3-choose">' + esc(copy('choose')) + ' ' + accentName(possessive(name)) + ' ' + esc(copy('portions')) + '</h2>' +
          '<div class="w3-options">' + cards + '</div>' +
          '<div class="w3-actions">' +
            '<div class="w3-summary">' +
              '<p class="w3-summary__price" data-w3-summary></p>' +
              '<p class="w3-days">' + esc(fill(copy('days'), { days: String(model.horizon) })) + '</p>' +
            '</div>' +
            '<button type="button" class="wizard-primary-button" data-w3-go>' + esc(buttonLabel) + '</button>' +
            '<button type="button" class="w3-recipes" data-open-wizard-flavor-modal="plan">' + esc(copy('recipes')) + '</button>' +
          '</div>' +
        '</section>' +
        storyHtml(handler, dog, flavorCount, bowls) +
      '</div>';
    if (keptBags) {
      var freshBags = rootEl.querySelector('.w3-bags');
      if (freshBags) freshBags.replaceWith(keptBags);
    } else {
      revealBags(rootEl.querySelector('.w3-bags'));
    }
    card.options.forEach(function (option) {
      if (option.hidden) return;
      var built = quoteKey(dog, option, model.combinedKg);
      if (priceCache[built.key]) option.quote = priceCache[built.key];
    });
    paintQuotes(handler, rootEl, card, selected);
    loadQuotes(handler, rootEl, dog, card, model.combinedKg, selected, token);
    rootEl.querySelectorAll('[data-w3-portion]').forEach(function (button) {
      button.addEventListener('click', function () {
        var portion = button.getAttribute('data-w3-portion');
        opened[index + ':' + portion] = true;
        state.setDogField(index, 'portion', portion);
        mountOverview(handler);
      });
    });
    var go = rootEl.querySelector('[data-w3-go]');
    if (go) {
      go.addEventListener('click', function () {
        var next = root.document.querySelector('[data-next-button]');
        if (next) next.click();
      });
    }
    var nextLabel = root.document.querySelector('[data-next-button] .next-button-label');
    if (nextLabel) nextLabel.textContent = buttonLabel;
    watchSticky(rootEl);
    var videoSlot = rootEl.querySelector('[data-w3-video]');
    if (keptVideo && videoSlot) videoSlot.replaceWith(keptVideo);
    else mountVideo(videoSlot);
    startBowl(rootEl.querySelector('[data-w3-bowl]'), bowls);
    if (root.bzSyncHeadingAccents) {
      try { root.bzSyncHeadingAccents(rootEl); } catch (e) {}
    }
  }

  function selectedExtra(state) {
    var id = state.extrasOn && state.extrasOn.w3;
    return EXTRAS.some(function (item) { return item.id === id; }) ? id : EXTRAS[0].id;
  }

  function extraNames(id) {
    var variant = extraMedia[id];
    var product = variant && variant.product && variant.product.title;
    var variantTitle = variant && variant.title;
    return {
      product: product || copy('extra_' + id),
      variant: variantTitle || ''
    };
  }

  function extraPriceText(handler, id) {
    var variant = extraMedia[id];
    if (!variant || variant.price == null) return '';
    return formatCents(handler, moneyStringToCents(variant.price), variant.currency);
  }

  function paintExtraPrice(handler, id) {
    var line = root.document.querySelector('[data-w3-extra-price]');
    if (line) line.textContent = fill(copy('extra_price'), { price: extraPriceText(handler, id) });
    paintExtraBar(handler, id);
  }

  function ensureExtraBar() {
    var footer = root.document.querySelector('.quiz-footer');
    if (!footer) return null;
    var bar = footer.querySelector('[data-w3-extra-bar]');
    if (bar) return bar;
    bar = root.document.createElement('div');
    bar.className = 'w3-extra-bar';
    bar.setAttribute('data-w3-extra-bar', '');
    bar.innerHTML = '<span class="w3-extra-bar__name" data-w3-extra-name></span>' +
      '<span class="w3-extra-bar__price"><span class="w3-price-was" data-w3-extra-was></span>' +
      '<span class="w3-extra-free" data-w3-extra-free></span></span>';
    var buttons = footer.querySelector('.footer-buttons');
    footer.insertBefore(bar, buttons || null);
    return bar;
  }

  function paintExtraBar(handler, id) {
    var bar = ensureExtraBar();
    if (!bar) return;
    var names = extraNames(id);
    var name = bar.querySelector('[data-w3-extra-name]');
    var was = bar.querySelector('[data-w3-extra-was]');
    var free = bar.querySelector('[data-w3-extra-free]');
    if (name) name.textContent = [names.product, names.variant].filter(Boolean).join(' ');
    if (was) was.textContent = extraPriceText(handler, id);
    if (free) free.textContent = copy('extra_free');
  }

  function mountExtras(handler) {
    var rootEl = handler.currentStepElement && handler.currentStepElement.querySelector('[data-wizard-extras]');
    if (!rootEl) return;
    var state = handler.flow.state;
    var selected = selectedExtra(state);
    var cards = EXTRAS.map(function (item) {
      var variant = extraMedia[item.id];
      var names = extraNames(item.id);
      var image = variant && variant.image ? '<img alt="" src="' + esc(variant.image) + '">' : '';
      var title = esc(names.product);
      if (names.variant) {
        title += (names.product ? ' ' : '') + '<span class="' + item.accent + ' nowrap">' + esc(names.variant) + '</span>';
      }
      return '<label class="w3-extra' + (item.id === selected ? ' is-selected' : '') + '">' +
        '<span class="w3-extra__body">' +
          '<span class="w3-extra__media">' + image + '</span>' +
          '<span class="w3-extra__copy">' +
            '<h5 class="w3-extra__title">' + title + '</h5>' +
            '<a href="#" class="w3-extra__details" data-open-flavor-modal="' + item.modal + '">' + esc(copy('extra_details')) + '</a>' +
            extraAllergyWarning(handler, item.id) +
          '</span>' +
        '</span>' +
        '<input type="radio" name="w3-extra" value="' + item.id + '"' + (item.id === selected ? ' checked' : '') + '>' +
        '<span class="w3-radio" aria-hidden="true"></span>' +
      '</label>';
    }).join('');
    rootEl.innerHTML =
      '<div class="w3-extras">' +
        '<div class="w3-extras__intro">' +
          '<h2>' + esc(copy('extra_title_before')) + ' <span class="accent accent--freshwater shape_1 nowrap">' + esc(copy('extra_title_accent')) + '</span> ' + esc(copy('extra_title_after')) + '</h2>' +
          '<p class="w3-extra-sub" data-w3-extra-price>' + esc(fill(copy('extra_price'), { price: extraPriceText(handler, selected) })) + '</p>' +
          '<img class="w3-extras__photos" alt="" src="https://cdn.shopify.com/s/files/1/0919/3534/2856/files/hero-photos.webp?v=1790946311">' +
          '<ul class="w3-extra-usps">' +
            '<li><img alt="" src="' + TICK + '" width="16" height="11"><span>' + esc(copy('extra_usp_1')) + '</span></li>' +
            '<li><img alt="" src="' + TICK + '" width="16" height="11"><span>' + esc(copy('extra_usp_2')) + '</span></li>' +
          '</ul>' +
        '</div>' +
        '<div class="w3-extras__list">' + cards + '</div>' +
      '</div>';
    rootEl.querySelectorAll('input[name="w3-extra"]').forEach(function (input) {
      input.addEventListener('change', function () {
        rootEl.querySelectorAll('.w3-extra').forEach(function (row) {
          row.classList.toggle('is-selected', row.querySelector('input').checked);
        });
        paintExtraPrice(handler, input.value);
      });
    });
    rootEl.querySelectorAll('[data-open-flavor-modal]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var modal = root.document.querySelector('.flavor-modal-' + link.getAttribute('data-open-flavor-modal'));
        if (modal) modal.dataset.state = 'open';
      });
    });
    paintExtraBar(handler, selected);
    ensureSkip(handler);
    if (root.bzSyncHeadingAccents) {
      try { root.bzSyncHeadingAccents(rootEl); } catch (e) {}
    }
  }

  function ensureSkip(handler) {
    var footer = root.document.querySelector('.quiz-footer .footer-buttons');
    if (!footer || footer.querySelector('[data-w3-skip]')) return;
    var button = root.document.createElement('button');
    button.type = 'button';
    button.className = 'wizard-card-button';
    button.setAttribute('data-w3-skip', '');
    var label = root.document.createElement('span');
    label.className = 'w3-skip-label';
    label.textContent = copy('skip');
    var spinner = root.document.createElement('span');
    spinner.className = 'next-button-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    button.appendChild(label);
    button.appendChild(spinner);
    button.addEventListener('click', function () {
      if (button.disabled) return;
      handler.flow.state.extrasOn.w3 = '';
      if (handler._runWizardCartAndCheckout) {
        handler._runWizardCartAndCheckout({ mode: 'checkout', loadingTarget: 'skip' });
      }
    });
    footer.insertBefore(button, footer.firstChild);
  }

  function loadExtras(handler) {
    var api = handler.flow && handler.flow.shopifyAPI;
    var pending = EXTRAS.filter(function (item) { return !extraMedia[item.id]; });
    if (!api || !api.getVariant || !pending.length) {
      mountExtras(handler);
      return;
    }
    Promise.all(pending.map(function (item) {
      var row = ((journey() && journey().products && journey().products.extras) || []).find(function (extra) {
        return extra.id === item.id;
      });
      if (!row) return null;
      return api.getVariant(row.shopify_variant_id).then(function (variant) {
        if (variant) extraMedia[item.id] = variant;
      }).catch(function () {});
    })).then(function () {
      if (handler.flow.state.getCurrentStep && handler.flow.state.getCurrentStep() === 'extras') mountExtras(handler);
    });
  }

  function syncShell(step) {
    var box = root.document && root.document.querySelector('.quiz-container');
    var w3 = root.BzWizard && root.BzWizard.id && root.BzWizard.id() === 'w3';
    if (box) {
      box.classList.toggle('w3-plan-active', !!(w3 && step === 'plan_overview'));
      box.classList.toggle('w3-extras-active', !!(w3 && step === 'extras'));
      if (!(w3 && step === 'plan_overview')) box.classList.remove('w3-sticky-on');
    }
    if (!(w3 && step === 'extras')) {
      var skip = root.document && root.document.querySelector('[data-w3-skip]');
      var extraBar = root.document && root.document.querySelector('[data-w3-extra-bar]');
      if (skip) skip.remove();
      if (extraBar) extraBar.remove();
    }
    if (!(w3 && step === 'plan_overview') && stickyObserver) {
      stickyObserver.disconnect();
      stickyObserver = null;
    }
    if (!(w3 && step === 'plan_overview')) stopBowl();
    if (w3) {
      paintOffer();
      var help2 = root.document.querySelector('[data-eating-help-line="2"]');
      var help3 = root.document.querySelector('[data-eating-help-line="3"]');
      if (help2 && copy('help_2')) help2.textContent = copy('help_2');
      if (help3 && copy('help_3')) help3.textContent = copy('help_3');
    }
  }

  function paintOffer() {
    var el = root.document && root.document.querySelector('[data-wizard-offer-text]');
    var text = copy('offer');
    if (!el || !text) return;
    el.innerHTML = text;
  }

  function mount(handler, step) {
    syncShell(step);
    if (step === 'plan_overview') mountOverview(handler);
    if (step === 'extras') loadExtras(handler);
  }

  function advanceDog(handler) {
    var state = handler.flow.state;
    var dogs = state.ensureDogs();
    var index = activeIndex(state);
    if (index < dogs.length - 1) {
      setPlanDog(handler, index + 1);
      mountOverview(handler);
      return true;
    }
    return false;
  }

  function retreatDog(handler) {
    var state = handler.flow.state;
    var index = activeIndex(state);
    if (index <= 0) return false;
    setPlanDog(handler, index - 1);
    mountOverview(handler);
    return true;
  }

  function sellingPlanFor(config, days) {
    var map = (config && config.sellingPlanMapping) || {};
    var keys = Object.keys(map).map(Number).filter(function (n) { return Number.isFinite(n); }).sort(function (a, b) { return a - b; });
    if (!keys.length) return '';
    var target = Math.max(1, Math.round(days));
    if (map[String(target)]) return String(map[String(target)]);
    var best = keys[0];
    keys.forEach(function (key) {
      if (Math.abs(key - target) < Math.abs(best - target)) best = key;
    });
    return String(map[String(best)] || '');
  }

  function foodVariant(flavor, portion, kg) {
    var rows = (journey() && journey().products && journey().products.ongoing_food && journey().products.ongoing_food.variants) || [];
    var weight = Math.min(Math.max(Number(kg) || 1, 1), 100);
    return rows.find(function (row) {
      return row.flavor === flavor && row.portion === portion && weight >= row.min_kg && weight <= row.max_kg;
    });
  }

  function extraVariant(id) {
    return ((journey() && journey().products && journey().products.extras) || []).find(function (row) {
      return row.id === id;
    });
  }

  async function buildCheckout(handler) {
    var model = prepare(handler);
    var state = handler.flow.state;
    var planId = sellingPlanFor(handler.flow.config, model.horizon);
    if (!planId) throw new Error('No selling plan for ' + model.horizon + ' days');
    var flow = root.BzWizard.flow();
    var journeyId = root.BzWizard.id();
    var household = {
      _journey_id: journeyId,
      _acquisition_flow: flow,
      _plan_type: (journey().pricing && journey().pricing.first_box_kind) || 'full'
    };
    var forLabel = copy('cart_for') || (nl() ? 'Voor' : 'For');
    var payload = JSON.stringify(model.dogs.map(function (dog, index) {
      var portion = dog.portion === 'half' || dog.portion === 'topper' ? dog.portion : 'complete';
      return {
        name: dog.name,
        portion: portion,
        flavors: dog.flavors || [],
        bags: optionOf(model.cards[index], portion).ship
      };
    }));
    function dogProps(dog) {
      var props = Object.assign({ _pet_name: dog.name || '' }, household);
      if (dog.petMetaobjectId) props._pet_metaobject_id = String(dog.petMetaobjectId);
      if (dog.name) props[forLabel] = dog.name;
      return props;
    }
    var items = [];
    model.dogs.forEach(function (dog, index) {
      var portion = dog.portion === 'half' || dog.portion === 'topper' ? dog.portion : 'complete';
      var ship = optionOf(model.cards[index], portion).ship;
      var dist = root.FlavorDistribution
        ? root.FlavorDistribution.calculateFlavorDistribution(ship, dog.flavors || [])
        : {};
      var props = dogProps(dog);
      ORDER.forEach(function (id) {
        var qty = dist[id] || 0;
        if (!qty) return;
        var row = foodVariant(id, portion, model.combinedKg);
        if (!row || !row.shopify_variant_id) return;
        items.push({
          variantId: parseInt(row.shopify_variant_id, 10),
          quantity: qty,
          sellingPlanId: planId,
          properties: Object.assign({}, props)
        });
      });
    });
    if (!items.length) throw new Error('Wizard 3 has no food lines');
    items[0].properties = Object.assign({}, items[0].properties, { _journey_payload: payload });
    var giftId = state.extrasOn && state.extrasOn.w3;
    var gift = giftId ? extraVariant(giftId) : null;
    if (gift && gift.shopify_variant_id) {
      items.push({
        variantId: parseInt(gift.shopify_variant_id, 10),
        quantity: 1,
        sellingPlanId: planId,
        properties: Object.assign({ _journey_gift: '1' }, household)
      });
    }
    model.dogs.forEach(function (dog) {
      var props = dogProps(dog);
      sampleFlavors(dog).forEach(function (id) {
        if (!SAMPLES[id]) return;
        items.push({
          variantId: parseInt(SAMPLES[id], 10),
          quantity: 1,
          properties: Object.assign({ _journey_gift: '1' }, props)
        });
      });
    });
    var scoop = journey() && journey().products && journey().products.scoop;
    if (scoop && scoop.shopify_variant_id) {
      items.push({
        variantId: parseInt(scoop.shopify_variant_id, 10),
        quantity: 1,
        properties: Object.assign({ _journey_gift: '1' }, household)
      });
    }
    var guide = journey() && journey().products && journey().products.guide;
    if (guide && guide.shopify_variant_id) {
      items.push({
        variantId: parseInt(guide.shopify_variant_id, 10),
        quantity: 1,
        properties: Object.assign({ _journey_gift: '1' }, household)
      });
    }
    return {
      cartItems: items,
      distribution: {},
      fullPlanBagCount: model.cards.reduce(function (sum, card, index) {
        return sum + optionOf(card, model.dogs[index].portion).ship;
      }, 0),
      matchDays: model.horizon,
      multiplier: 1,
      calculations: {},
      selectedFlavorsTrial: state.selectedFlavorsTrial || [],
      trialVariantId: items[0].variantId,
      nextShipmentOffsetDays: model.horizon,
      flow: flow
    };
  }

  root.WizardW3 = {
    mount: mount,
    syncShell: syncShell,
    advanceDog: advanceDog,
    retreatDog: retreatDog,
    planButtonLabel: planButtonLabel,
    buildCheckout: buildCheckout,
    hasSamples: function (state) {
      var dogs = state && state.ensureDogs ? state.ensureDogs() : [];
      return dogs.some(function (dog) { return sampleFlavors(dog).length > 0; });
    },
    activeDog: function (state) {
      var dogs = state.ensureDogs();
      return dogs[activeIndex(state)] || dogs[0];
    },
    activeIndex: activeIndex,
    maxFlavors: function () {
      if (!lastHandler) return 3;
      var model = compute(lastHandler);
      var index = activeIndex(lastHandler.flow.state);
      var dog = model.dogs[index];
      if (!dog) return 1;
      return Math.max(1, Math.min(3, optionOf(model.cards[index], dog.portion).ship));
    },
    shipBags: function (handler) {
      var model = prepare(handler);
      var index = activeIndex(handler.flow.state);
      var dog = model.dogs[index];
      return optionOf(model.cards[index], dog.portion).ship;
    },
    _shipCount: shipCount
  };
})(typeof window !== 'undefined' ? window : globalThis);
